import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['frame']
  static values = { url: String }

  connect () {
    this.load()
  }

  load () {
    if (!this.element.open || !this.hasFrameTarget || !this.hasUrlValue) return
    if (this.frameTarget.hasAttribute('src')) return

    this.frameTarget.src = this.urlValue
  }
}
